var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-card"},_vm._l((_vm.data),function(value,name,index){return _c('div',{key:index,staticClass:"info-card__field"},[_c('div',{staticClass:"info-card__name"},[_vm._v(" "+_vm._s(name)+": ")]),_c('div',{staticClass:"info-card__cell"},[_vm._v(" "+_vm._s(value)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }